// extracted by mini-css-extract-plugin
export default {"axis":"components--axis--sgBPk","yAxis":"components--yAxis--JrubH","xAxis":"components--xAxis--iKpt1"};